import { NgClass } from '@angular/common';
import { Component, Input, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';

import { BaseSmartInputComponent } from './base-smart-input.component';

@Component({
  selector: 'app-smart-input-string',
  templateUrl: './smart-input-string.component.html',
  styleUrls: ['./smart-input-string.component.css'],
  standalone: true,
  imports: [FormsModule, InputTextModule, NgClass, ReactiveFormsModule, TranslateModule],
})
export class SmartInputStringComponent extends BaseSmartInputComponent<string> {
  readonly type = input<'input' | 'textarea'>('input');
  readonly disabled = input<boolean>(false);
  // TODO: move same logic to all smart input or a wrapper
  readonly mode = input<'input' | 'composite'>('input');
  readonly animated = input<boolean>(true);
  // TODO: move same logic to all smart input or a wrapper
  @Input() labelClasses?: string;
}
